import { ThemeIcon } from '@mantine/core';
import { AppIcon } from './AppIcon';

/**
 * Soft, rounded coloured circle holding an icon.
 * Reused by stats cards, the attention list and the live-activity feed.
 */
export function IconBadge({ icon, color = 'brand', size = 44, radius = 'xl', iconSize }) {
  return (
    <ThemeIcon variant="light" color={color} size={size} radius={radius}>
      <AppIcon name={icon} size={iconSize ?? Math.round(size * 0.5)} />
    </ThemeIcon>
  );
}

export default IconBadge;
